export default "__VITE_ASSET__3jVr99se__"